"use client";

import { c as _c } from "react/compiler-runtime";
import { zodResolver } from "@hookform/resolvers/zod";
import { Flex, Form, Input, TextHeading } from "@opensea/ui-kit";
import { useForm } from "react-hook-form";
import { useTranslations } from "use-intl";
import { z } from "zod";
import { Button } from "../../../components/Button";
import { useIsFormSubmitDisabled } from "../../../lib/form/valid";
import { emailSchema } from "../../../lib/zod/schema";
const formSchema = z.object({
  email: emailSchema
});
export function EmailInputStep(t0) {
  const $ = _c(31);
  const {
    onSubmit,
    onChangePaymentMethod
  } = t0;
  const t = useTranslations("wallet.EmailInputStep");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      defaultValues: {
        email: ""
      },
      resolver: zodResolver(formSchema),
      mode: "onSubmit"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    control,
    register,
    handleSubmit
  } = useForm(t1);
  const isFormSubmitDisabled = useIsFormSubmitDisabled(control);
  let t2;
  if ($[1] !== handleSubmit || $[2] !== onSubmit) {
    t2 = handleSubmit(onSubmit);
    $[1] = handleSubmit;
    $[2] = onSubmit;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("loginTitle");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <TextHeading asChild={true} className="mb-6 block" size="md"><label htmlFor="connect-embedded-wallet-email-input">{t3}</label></TextHeading>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("emailPlaceholder");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== register) {
    t6 = register("email");
    $[10] = register;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <Input autoFocus={true} id="connect-embedded-wallet-email-input" placeholder={t5} size="lg" type="email" {...t6} />;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== onChangePaymentMethod || $[16] !== t) {
    t8 = onChangePaymentMethod && <Button onClick={onChangePaymentMethod} type="button" variant="secondary">{t("seeMore")}</Button>;
    $[15] = onChangePaymentMethod;
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t) {
    t9 = t("continue");
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== isFormSubmitDisabled || $[21] !== t9) {
    t10 = <Button disabled={isFormSubmitDisabled} type="submit">{t9}</Button>;
    $[20] = isFormSubmitDisabled;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t8) {
    t11 = <Flex className="mt-6 justify-between gap-3">{t8}{t10}</Flex>;
    $[23] = t10;
    $[24] = t8;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11 || $[27] !== t2 || $[28] !== t4 || $[29] !== t7) {
    t12 = <Form onSubmit={t2}>{t4}{t7}{t11}</Form>;
    $[26] = t11;
    $[27] = t2;
    $[28] = t4;
    $[29] = t7;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  return t12;
}